import { vnModule } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule";

import { home } from "./home";
import { menu_list } from "./menu_list";
import { website_menu } from "./website_menu";
import { users_edit } from "./users_edit";
import { users } from "./users";
import { login } from "./login";
import { menu_mod } from "./menu";
import { header } from "./header";
import { topics } from "./topics";
import { topics_edit } from "./topics_edit";
import { articles } from "./articles";
import { articles_edit_new } from "./articles_edit_new";
import { articles_edit } from "./articles_edit"
import { tags_edit } from "./tags_edit";
import { tags_import } from "./tags_import";
import { reset_password } from "./reset_password";
import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { users_profile } from "./users_profile";
import { users_profile_new } from "./users_profile_new";
import { transactions_edit } from "./transactions_edit";
import { transactions } from "./transactions";
import { transactions_verification } from "./transactions_verification";
import { transactions_delete } from "./transactions_delete";
import { transactions_payment } from "./transactions_payment";
import { centralized_payment } from "./centralized_payment";
import { transactions_payment_summary } from "./transactions_payment_summary";
import { transactions_payment_summary_printable } from "./transactions_payment_summary_printable";
import { transactions_recurring } from "./transactions_recurring";
import { transactions_recurring_edit } from "./transactions_recurring_edit";
import { transactions_slip } from "./transactions_slip";
import { transactions_slip_detail } from "./transactions_slip_detail";
import { logs } from "./logs";
import { accounting_report } from "./accounting_report";
import { tasks } from "./tasks";
import { accounting_report_by_account } from "./accounting_report_by_account";
import { accounting_report_by_user } from "./accounting_report_by_user";
import { articles_view } from "./articles_view";
import { articles_view_new } from "./articles_view_new";
import { config_home_page } from "./config_home_page";
import { job_profiles } from "./job_profiles";
import { job_profiles_view } from "./job_profiles_view";
import { job_profiles_edit } from "./job_profiles_edit";
import { candidate } from "./candidate";
import { job_applications } from "./job_applications";
import { job_applications_view } from "./job_applications_view";
import { job_applications_edit } from "./job_applications_edit";
import { roles } from "../../vendor/valnet/valnet_jslib/vnApp/roles";
import { roles_edit } from "../../vendor/valnet/valnet_jslib/vnApp/roles_edit";
import { roles_view } from "../../vendor/valnet/valnet_jslib/vnApp/roles_view";
import { announcement } from "./announcement";
import { about } from "./about";
import { articles_30_day_performance } from "./articles_30_day_performance";
import { categories } from "./categories";
import { tags } from "./tags";
import { config_categories } from "./config_categories";
import { config_categories_view } from "./config_categories_view";
import { config_categories_edit } from "./config_categories_edit";
import { config_categories_tag_pin_edit } from "./config_categories_tag_pin_edit";
import { config_tags } from "./config_tags";
import { config_tags_view } from "./config_tags_view";
import { config_tags_edit } from "./config_tags_edit";
import { content_preset } from "./content_preset";
import { content_preset_view } from "./content_preset_view";
import { content_preset_edit } from "./content_preset_edit";
import { field } from "./field";
import { field_view } from "./field_view";
import { field_edit } from "./field_edit";
import { mailing_list } from "./mailing_list";
import { mailing_list_view } from "./mailing_list_view";
import { mailing_list_edit } from "./mailing_list_edit";
import { external_mailing_list } from "./external_mailing_list";
import { external_mailing_list_view } from "./external_mailing_list_view";
import { external_mailing_list_edit } from "./external_mailing_list_edit";
import { signup_form } from "./signup_form";
import { signup_form_view } from "./signup_form_view";
import { signup_form_edit } from "./signup_form_edit";
import { popup } from "./popup";
import { popup_view } from "./popup_view";
import { popup_edit } from "./popup_edit";
import { recategorization } from "./recategorization";
import { production_volume_report } from "./production_volume_report";
import { article_10_day_performance } from "./article_10_day_performance";
import { static_page } from "./static_page";
import { static_page_view } from "./static_page_view";
import { static_page_edit } from "./static_page_edit";
import { listing_pages } from "./listing_pages";
import { listing_page_edit } from "./listing_page_edit";
import { listing_page_view } from "./listing_page_view";
import { polls } from "./polls";
import { polls_edit } from "./polls_edit";
import { polls_view } from "./polls_view";
import { config_sidebar } from "./config_sidebar";
import { config_general } from "./config_general";
import { tags_view } from "./tags_view";
import { tagTypes } from "./tagTypes";
import { tagTypes_edit } from "./tagTypes_edit";
import { tagTypes_view } from "./tagTypes_view";
import { tagRatings } from "./tagRatings";
import { operations_logs } from "./operation_logs";
import { config_user_profiles } from "./config_user_profiles";
import { config_my_modules } from "./config_my_modules";
import { offboarding } from "./offboarding";
import { config_article_pages } from "./config_article_pages";
import { header_featured_articles_edit } from "./header_featured_articles_edit";
import { republish_opportunities_report } from "./republish_opportunities_report";
import { article_session_edit } from "./article_session_edit";
import { bonus_accrual_by_brand } from "./bonus_accrual_by_brand";
import { accounting_report_by_rolegroup } from "./accounting_report_by_rolegroup";
import { tasks_edit } from "./tasks_edit";
import { topic_recommendation_report } from "./topic_recommendation_report";
import { config_suggested_articles } from "./config_suggested_articles";
import { watchlist } from "./watchlist";
import { dashboard } from "./dashboard";
import { author_management } from "./author_management";
import { website_users } from "./website_users";
import { website_users_edit } from "./website_users_edit";
import { website_users_import } from "./website_users_import";
import { website_users_comments} from "./website_users_comments";
import { config_auto_linker } from "./config_auto_linker";
import { newsletter_mail_edit } from "./newsletter_mail_edit";
import { newsletter_mail_view } from "./newsletter_mail_view";
import { newsletter_mails } from "./newsletter_mails";
import { newsletter_mail_delivery } from "./newsletter_mail_delivery";
import { newsletter_interaction_emails } from "./newsletter_interaction_emails";
import { newsletter_interaction_email_view } from "./newsletter_interaction_email_view";
import { newsletter_interaction_email_edit } from "./newsletter_interaction_email_edit";
import { article_session_view } from "./article_session_view";
import { newsletter_templates } from "./newsletter_templates";
import { newsletter_template_view } from "./newsletter_template_view";
import { newsletter_template_edit } from "./newsletter_template_edit";
import { vignettes } from "./vignettes";
import { vignettes_edit } from "./vignettes_edit";
import { vignettes_view } from "./vignettes_view";
import { videos } from "./videos";
import { videos_view } from "./videos_view";
import { videos_edit } from "./videos_edit";
import { images } from "./images";
import { images_view } from "./images_view";
import { images_edit } from "./images_edit";
import { dashboard_pwa } from "./dashboard_pwa";
import { header_pwa } from "./header_pwa";
import { menu_mod_pwa } from "./menu_pwa";
import { tag_type_subscriptions } from "./tag_type_subscriptions";
import { tag_type_subscriptions_edit } from "./tag_type_subscriptions_edit";
import { rss_feed } from "./rss_feed";
import {config_login} from "./config_login";
import {config_ai} from "./config_ai";
import { content_value_reporting } from "./content_value_reporting";
import { grey_keywords } from "./grey_keywords";
import { contentModeration } from "./contentModeration";
import { channels_playlists } from "./channels_playlists";
import { channels_playlists_view } from "./channels_playlists_view";
import { channels_playlists_edit } from "./channels_playlists_edit";
import { channels } from "./channels";
import { channels_view } from "./channels_view";
import { channels_edit } from "./channels_edit";
import { thread_suggestions } from "./thread_suggestions";
import { header_menu } from "./header_menu";
import { header_sub_menu_edit } from "./header_sub_menu_edit";
import { header_menu_edit } from "./header_menu_edit";
import { config_promotion } from "./config_promotion";
import { config_promotion_view } from "./config_promotion_view";
import { config_promotion_edit } from "./config_promotion_edit";
import { privacy_policy } from "./privacy_policy";
import { terms_of_use } from "./terms_of_use";
import sensai_vault from "./sensAI_vault";
import {config_segments} from "./config_segments";

export class pageFactory {

    protected lastModule: any;

    get_actionHandler(typeName: string, vnAppZone: vnAppZone): vnModule {
        let obj: vnModule;
        console.log("Instantiating module [" + typeName + "]");

        if (vnAppZone.zoneName == "Content") {
            if (vnAppZone.loadedModule) {
                vnAppZone.lastLoadedModule = vnAppZone.loadedModule
            }

            if (vnAppZone.lastLoadedModule) {
                vnAppZone.lastLoadedModule.cleanup();
                vnAppZone.lastLoadedModule = null;
            }
        }

        this.resetClasses();

        switch (typeName) {
            case "home":
                obj = new home(vnAppZone);
                break;
            case "website_menu":
                obj = new website_menu(vnAppZone);
                break;
            case "header_menu":
                obj = new header_menu(vnAppZone);
                break;
            case "header_menu_edit":
                obj = new header_menu_edit(vnAppZone);
                break;
            case "header_sub_menu_edit":
                obj = new header_sub_menu_edit(vnAppZone);
                break;
            case "menu_list":
                obj = new menu_list(vnAppZone);
                break;
            case "header_featured_articles_edit":
                obj = new header_featured_articles_edit(vnAppZone);
                break;
            case "users":
                obj = new users(vnAppZone);
                break;
            case "users_edit":
                obj = new users_edit(vnAppZone);
                break;
            case "users_profile":
                obj = new users_profile(vnAppZone);
                break;
            case "users_profile_new":
                obj = new users_profile_new(vnAppZone);
                break;
            case "login":
                obj = new login(vnAppZone);
                break;
            case "menu":
                obj = new menu_mod(vnAppZone);
                break;
            case "menu_pwa":
                obj = new menu_mod_pwa(vnAppZone);
                break;
            case "header":
                obj = new header(vnAppZone);
                break;
            case "header_pwa":
                obj = new header_pwa(vnAppZone);
                break;
            case "reset_password":
                obj = new reset_password(vnAppZone);
                break;
            case "topics":
                obj = new topics(vnAppZone);
                break;
            case "topics_edit":
                obj = new topics_edit(vnAppZone);
                break;
            case "articles":
                obj = new articles(vnAppZone);
                break;
            case "articles_30_day_performance":
                obj = new articles_30_day_performance(vnAppZone);
                break;
            case "author_management":
                obj = new author_management(vnAppZone);
                break;
            case "content_value_reporting":
                obj = new content_value_reporting(vnAppZone);
                break;
            case "articles_view":
                obj = new articles_view(vnAppZone);
                break;
            case "articles_view_new":
                obj = new articles_view_new(vnAppZone);
                break;
            case "articles_edit":
                obj = new articles_edit(vnAppZone);
                break;
            case "articles_edit_new":
                obj = new articles_edit_new(vnAppZone);
                break;
            case "tags_edit":
                obj = new tags_edit(vnAppZone);
                break;
            case "tags_import":
                obj = new tags_import(vnAppZone);
                break;
            case "transactions":
                obj = new transactions(vnAppZone);
                break;
            case "transactions_verification":
                obj = new transactions_verification(vnAppZone);
                break;
            case "transactions_edit":
                obj = new transactions_edit(vnAppZone);
                break;
            case "transactions_delete":
                obj = new transactions_delete(vnAppZone);
                break;
            case "transactions_payment":
                obj = new transactions_payment(vnAppZone);
                break;
            case "global_payment":
                obj = new centralized_payment(vnAppZone);
                break;
            case "transactions_payment_summary_printable":
                obj = new transactions_payment_summary_printable(vnAppZone);
                break;
            case "transactions_payment_summary":
                obj = new transactions_payment_summary(vnAppZone);
                break;
            case "transactions_recurring":
                obj = new transactions_recurring(vnAppZone);
                break;
            case "transactions_recurring_edit":
                obj = new transactions_recurring_edit(vnAppZone);
                break;
            case "transactions_slip":
                obj = new transactions_slip(vnAppZone);
                break;
            case "transactions_slip_detail":
                obj = new transactions_slip_detail(vnAppZone);
                break;
            case "logs":
                obj = new logs(vnAppZone);
                break;
            case "accounting_report":
                obj = new accounting_report(vnAppZone);
                break;
            case "accounting_report_by_account":
                obj = new accounting_report_by_account(vnAppZone);
                break;
            case "bonus_accrual_by_brand":
                obj = new bonus_accrual_by_brand(vnAppZone);
                break;
            case "accounting_report_by_user":
                obj = new accounting_report_by_user(vnAppZone);
                break;
            case "tasks":
                obj = new tasks(vnAppZone);
                break;
            case "tasks_edit":
                obj = new tasks_edit(vnAppZone);
                break;
            case "config_home_page":
                obj = new config_home_page(vnAppZone);
                break;
            case "job_profiles":
                obj = new job_profiles(vnAppZone);
                break;
            case "job_profiles_view":
                obj = new job_profiles_view(vnAppZone);
                break;
            case "job_profiles_edit":
                obj = new job_profiles_edit(vnAppZone);
                break;
            case "candidate":
                obj = new candidate(vnAppZone);
                break;
            case "job_applications":
                obj = new job_applications(vnAppZone);
                break;
            case "job_applications_view":
                obj = new job_applications_view(vnAppZone);
                break;
            case "job_applications_edit":
                obj = new job_applications_edit(vnAppZone);
                break;
            case "roles":
                obj = new roles(vnAppZone);
                break;
            case "roles_edit":
                obj = new roles_edit(vnAppZone);
                break;
            case "roles_view":
                obj = new roles_view(vnAppZone);
                break;
            case "announcement":
                obj = new announcement(vnAppZone);
                break;
            case "about":
                obj = new about(vnAppZone);
                break;
            case "categories":
                obj = new categories(vnAppZone);
                break;
            case "tags":
                obj = new tags(vnAppZone);
                break;
            case "config_categories":
                obj = new config_categories(vnAppZone);
                break;
            case "config_categories_view":
                obj = new config_categories_view(vnAppZone);
                break;
            case "config_categories_edit":
                obj = new config_categories_edit(vnAppZone);
                break;
            case "config_categories_tag_pin_edit":
                obj = new config_categories_tag_pin_edit(vnAppZone);
                break;
            case "config_tags":
                obj = new config_tags(vnAppZone);
                break;
            case "config_tags_view":
                obj = new config_tags_view(vnAppZone);
                break;
            case "config_tags_edit":
                obj = new config_tags_edit(vnAppZone);
                break;
            case "content_preset":
                obj = new content_preset(vnAppZone);
                break;
            case "content_preset_view":
                obj = new content_preset_view(vnAppZone);
                break;
            case "content_preset_edit":
                obj = new content_preset_edit(vnAppZone);
                break;
            case "field":
                obj = new field(vnAppZone);
                break;
            case "field_view":
                obj = new field_view(vnAppZone);
                break;
            case "field_edit":
                obj = new field_edit(vnAppZone);
                break;
            case "mailing_list":
                obj = new mailing_list(vnAppZone);
                break;
            case "mailing_list_view":
                obj = new mailing_list_view(vnAppZone);
                break;
            case "mailing_list_edit":
                obj = new mailing_list_edit(vnAppZone);
                break;
            case "external_mailing_list":
                obj = new external_mailing_list(vnAppZone);
                break;
            case "external_mailing_list_view":
                obj = new external_mailing_list_view(vnAppZone);
                break;
            case "external_mailing_list_edit":
                obj = new external_mailing_list_edit(vnAppZone);
                break;
            case "signup_form":
                obj = new signup_form(vnAppZone);
                break;
            case "signup_form_view":
                obj = new signup_form_view(vnAppZone);
                break;
            case "signup_form_edit":
                obj = new signup_form_edit(vnAppZone);
                break;
            case "popup":
                obj = new popup(vnAppZone);
                break;
            case "popup_view":
                obj = new popup_view(vnAppZone);
                break;
            case "popup_edit":
                obj = new popup_edit(vnAppZone);
                break;
            case "recategorization":
                obj = new recategorization(vnAppZone);
                break;
            case "article_10_day_performance":
                obj = new article_10_day_performance(vnAppZone);
                break;
            case "production_volume_report":
                obj = new production_volume_report(vnAppZone);
                break;
            case "static_page":
                obj = new static_page(vnAppZone);
                break;
            case "static_page_view":
                obj = new static_page_view(vnAppZone);
                break;
            case "static_page_edit":
                obj = new static_page_edit(vnAppZone);
                break;
            case "listing_pages":
                obj = new listing_pages(vnAppZone);
                break;
            case "listing_page_view":
                obj = new listing_page_view(vnAppZone);
                break;
            case "listing_page_edit":
                obj = new listing_page_edit(vnAppZone);
                break;
            case "polls":
                obj = new polls(vnAppZone);
                break;
            case "polls_edit":
                obj = new polls_edit(vnAppZone);
                break;
            case "polls_view":
                obj = new polls_view(vnAppZone);
                break;
            case "config_sidebar":
                obj = new config_sidebar(vnAppZone);
                break;
            case "config_general":
                obj = new config_general(vnAppZone);
                break;
            case "config_user_profiles":
                obj = new config_user_profiles(vnAppZone);
                break;
            case "config_my_modules":
                obj = new config_my_modules(vnAppZone);
                break;
            case "tags_view":
                obj = new tags_view(vnAppZone);
                break;
            case "tagTypes":
                obj = new tagTypes(vnAppZone);
                break;
            case "tagTypes_view":
                obj = new tagTypes_view(vnAppZone);
                break;
            case "tagTypes_edit":
                obj = new tagTypes_edit(vnAppZone);
                break;
            case "tagRatings":
                    obj = new tagRatings(vnAppZone);
                    break;
            case "operation_logs":
                obj = new operations_logs(vnAppZone);
                break;
            case "config_article_pages":
                obj = new config_article_pages(vnAppZone);
                break;
            case "offboarding":
                obj = new offboarding(vnAppZone);
                break;
            case "republish_opportunities_report":
                obj = new republish_opportunities_report(vnAppZone);
                break;
            case "article_session_view":
                obj = new article_session_view(vnAppZone);
                break;
            case "article_session_edit":
                obj = new article_session_edit(vnAppZone);
                break;
            case "accounting_report_by_rolegroup":
                obj = new accounting_report_by_rolegroup(vnAppZone);
                break;
            case "topic_recommendation_report":
                obj = new topic_recommendation_report(vnAppZone);
                break;
            case "config_suggested_articles":
                obj = new config_suggested_articles(vnAppZone);
                break;
            case "watchlist":
                obj = new watchlist(vnAppZone);
                break;
            case "dashboard":
                obj = new dashboard(vnAppZone);
                break;
            case "website_users":
                obj = new website_users(vnAppZone);
                break;
            case "website_users_edit":
                obj = new website_users_edit(vnAppZone);
                break;
            case "website_users_import":
                obj = new website_users_import(vnAppZone);
                break;
            case "website_users_comments":
                obj = new website_users_comments(vnAppZone);
                break;
            case "grey_keywords":
                obj = new grey_keywords(vnAppZone);
                break;
            case "config_auto_linker":
                obj = new config_auto_linker(vnAppZone);
                break;
            case "newsletter_mail_edit":
                obj = new newsletter_mail_edit(vnAppZone);
                break;
            case "newsletter_mail_view":
                obj = new newsletter_mail_view(vnAppZone);
                break;
            case "newsletter_mails":
                obj = new newsletter_mails(vnAppZone);
                break;
            case "newsletter_mail_delivery":
                obj = new newsletter_mail_delivery(vnAppZone);
                break;
            case "newsletter_interaction_emails":
                obj = new newsletter_interaction_emails(vnAppZone);
                break;
            case "newsletter_interaction_email_view":
                obj = new newsletter_interaction_email_view(vnAppZone);
                break;
            case "newsletter_interaction_email_edit":
                obj = new newsletter_interaction_email_edit(vnAppZone);
                break;
            case "newsletter_templates":
                obj = new newsletter_templates(vnAppZone);
                break;
            case "newsletter_template_view":
                obj = new newsletter_template_view(vnAppZone);
                break;
            case "newsletter_template_edit":
                obj = new newsletter_template_edit(vnAppZone);
                break;
            case "vignettes":
                obj = new vignettes(vnAppZone);
                break;
            case "vignettes_edit":
                obj = new vignettes_edit(vnAppZone);
                break;
            case "vignettes_view":
                obj = new vignettes_view(vnAppZone);
                break;
            case "videos":
                obj = new videos(vnAppZone);
                break;
            case "videos_view":
                obj = new videos_view(vnAppZone);
                break;
            case "videos_edit":
                obj = new videos_edit(vnAppZone);
                break;
            case "images":
                obj = new images(vnAppZone);
                break;
            case "images_view":
                obj = new images_view(vnAppZone);
                break;
            case "images_edit":
                obj = new images_edit(vnAppZone);
                break;
            case "dashboard_pwa":
                obj = new dashboard_pwa(vnAppZone);
                break;
            case "tag_type_subscriptions":
                obj = new tag_type_subscriptions(vnAppZone);
                break;
            case "tag_type_subscriptions_edit":
                obj = new tag_type_subscriptions_edit(vnAppZone);
                break;
            case "rss_feed":
                obj = new rss_feed(vnAppZone);
                break;
            case "config_login":
                obj = new config_login(vnAppZone);
                break; 
            case "config_ai":
                obj = new config_ai(vnAppZone);
                break;
            case "contentModeration":
                obj = new contentModeration(vnAppZone);
                break;
            case "channels":
                obj = new channels(vnAppZone);
                break;
            case "channels_view":
                obj = new channels_view(vnAppZone);
                break;
            case "channels_edit":
                obj = new channels_edit(vnAppZone);
                break;
            case "channels_playlists":
                obj = new channels_playlists(vnAppZone);
                break;
            case "channels_playlists_view":
                obj = new channels_playlists_view(vnAppZone);
                break;
            case "channels_playlists_edit":
                obj = new channels_playlists_edit(vnAppZone);
                break;
            case "thread_suggestions":
                obj = new thread_suggestions(vnAppZone);
                break;
            case "config_promotion":
                obj = new config_promotion(vnAppZone);
                break;
            case "config_promotion_view":
                obj = new config_promotion_view(vnAppZone);
                break;
            case "config_promotion_edit":
                obj = new config_promotion_edit(vnAppZone);
                break;
            case "privacy_policy":
                obj = new privacy_policy(vnAppZone);
                break;
            case "terms_of_use":
                obj = new terms_of_use(vnAppZone);
                break;
            case "sensai_vault":
                obj = new sensai_vault(vnAppZone);
                break;
            case "config_segments":
                obj = new config_segments(vnAppZone);
                break;
        default:
                break;
        }

        return obj;
    }

    public resetClasses() {
        let body = document.body;
        if (body) {
            body.classList.remove("is-emaki-lab");
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/factory.ts